import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("da"); // Danish by default (reverseai.dk is a Danish-first site)

  useEffect(() => {
    try {
      const saved = localStorage.getItem("ph-lang");
      if (saved === "da" || saved === "en") setLangState(saved);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("ph-lang", l);
    } catch (e) {
      /* ignore */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within a LanguageProvider");
  return ctx;
};
